import IntlService from "ember-intl/services/intl";

/**
 * Format a float number as a string:
 * - if the number is an integer, returns it
 * - if the number is a float which has more than 3 digits, returns the Scientific Notation of the float
 * - otherwise returns the float value
 * i.e. 0.001 or 1e-4
 * @param {number} number
 */
export default function (intl, number) {
  const numberAsString = number.toString();
  const numberIsFloat = numberAsString.split(".").length > 1;
  if (!numberIsFloat) {
    return numberAsString;
  }
  if (numberAsString.split(".")[0].length > 1 || numberAsString.split(".")[1].length <= 3) {
    return intl.formatNumber(number, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }
  return intl.formatNumber(number, {
    notation: "scientific"
  });
}